import React from "react";

import { getTemplates } from "./CSSGridTemplate.helpers";
import * as Styled from "./CSSGridTemplate.styled";
import { keyArea } from "./area";
import { Areas, initAreas } from "./areas";
import type { CSSGridTemplateProps } from "./CSSGridTemplate.types";

export const CSSGridTemplate = <T extends Areas<string> = Areas<string>>({
  areas,
  areasProps,
  ...props
}: CSSGridTemplateProps<T>) => {
  const { AreaComponents, templates } = areas();

  return (
    <Styled.Root templates={getTemplates(templates)} {...props}>
      {Object.entries(AreaComponents).map(([key, AreaComponent]) => {
        const componentProps = (areasProps && areasProps[key]) || {};

        return (
          <AreaComponent key={AreaComponent[keyArea]} {...componentProps} />
        );
      })}
    </Styled.Root>
  );
};

/**
 * To combine columns formed through `repeat`
 *
 * Components should work with `className` prop
 * @example
 * Grid.areas({ First, Second, Third, Fourth });
 */
CSSGridTemplate.areas = initAreas;
